import React from 'react'
import { useSelector } from 'react-redux'
import { KeyboardBackspace } from '@mui/icons-material'
import { thirdly6, secondary1 } from 'styles/theme'
import { sidePanelEmptyText } from '../constants'

// פאנל צד לעמוד "מי נמדד" — נתוני ביצוע פר בית ספר, עיצוב זהה לעמוד נתוני ביצוע בהקטנה
const ExecutionSidePanel = ({ affiliations }) => {
    const { brokenDisplay } = useSelector(state => state.general)

    if (!affiliations?.length)
        return <div className='side-empty'>{sidePanelEmptyText}</div>

    return (
        <div>
            {affiliations.map(aff => (
                <div key={aff.id} className='mini-bar-row'>
                    <div className='mini-bar-label'>
                        <span className={`mini-bar-name ${brokenDisplay && 'blurred2'}`} title={aff.name}>{aff.name}</span>
                        <KeyboardBackspace sx={{ fontSize: 13, color: '#94a3b8', flexShrink: 0 }} />
                    </div>
                    <div className='mini-bar-content'>
                        <div className='mini-bar-caption'>
                            <b className={`${brokenDisplay && 'blurred2'}`}>{aff.test_taker_execution_count}</b>
                            {' מתוך '}
                            <b className={`${brokenDisplay && 'blurred2'}`}>{aff.test_taker_count}</b>
                            {' תלמידים '}
                            <b style={{ color: thirdly6 }}>{'סיימו'}</b>
                            {' לבצע את סוללת המבדקים'}
                            {aff.redo_batteries_count ?
                                <>
                                    {' | ב '}
                                    {aff.redo_batteries_count}
                                    {' סוללות נוספות יש מבדקים '}
                                    <b style={{ color: secondary1 }}>{'לביצוע חוזר'}</b>
                                </>
                                : ''}
                        </div>
                        <div className='mini-bar-track'>
                            <div
                                className='mini-bar-fill'
                                style={{ width: `${Math.min(aff.execution_percent || 0, 100)}%` }}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ExecutionSidePanel
